import type { ChatDocument } from '@models/chat';

export type ChatSearchTerms = Record<string, string>;

export function normalizeChatSearchQuery(searchQuery: string) {
  return searchQuery
    .toLowerCase()
    .replaceAll('#', '')
    .split(/\s+/)
    .filter(Boolean);
}

// every field a chat row can be recognized by, flattened into one lowercase
// string so a multi word query can be matched token by token
export function buildChatHaystack({
  chat,
  uid,
  extraTerms,
}: {
  chat: ChatDocument;
  uid: string | undefined;
  extraTerms?: string;
}) {
  const visibleContent = chat.messages
    .filter((message) => !message.is_auto || message.auto_recipient === uid)
    .map((message) => message.content ?? '');

  return [
    extraTerms ?? '',
    chat.last_msg ?? '',
    chat.order_num?.toString() ?? '',
    chat.case_num?.toString() ?? '',
    ...visibleContent,
  ]
    .join(' ')
    .toLowerCase();
}

export function chatMatchesSearchQuery({
  chat,
  uid,
  tokens,
  extraTerms,
}: {
  chat: ChatDocument;
  uid: string | undefined;
  tokens: string[];
  extraTerms?: string;
}) {
  if (!tokens.length) return true;
  const haystack = buildChatHaystack({ chat, uid, extraTerms });
  return tokens.every((token) => haystack.includes(token));
}
